import { DateTime } from 'luxon';

export class CycleSummary {
  id: number;
  projectId: number;
  projectName: string;
  ordinal: number;
  startDateUtc: DateTime;
  startDateOffset: number;
  endDateUtc?: DateTime;
  endDateOffset?: number;
  durationSeconds?: number;
  isActive: boolean;
}

export class CyclesPageData {
  projectId?: number;
  projectName: string;
  suggestedOrdinal: number;
  activeCycle?: CycleSummary;
  cycles: CycleSummary[] = [];
}

export interface CycleActivationRequest {
  ordinal: number;
  startDateUtc: string;
  startDateOffset: number;
  dailyLogDateUtc: string;
  dailyLogDateOffset: number;
}

export interface CycleEndRequest {
  cycleId: number;
  endDateUtc: string;
  endDateOffset: number;
  dailyLogDateUtc: string;
  dailyLogDateOffset: number;
  startNextCycle: boolean;
}

export class CycleChangeDeleteValidation {
  canDelete: boolean;
  cycleOrdinal?: number;
  blockingCycle?: CycleSummary;
  message?: string;
}

export interface CycleUpdateRequest {
  cycleId: number;
  startDateUtc?: string;
  startDateOffset?: number;
  endDateUtc?: string;
  endDateOffset?: number;
  dailyLogDateUtc: string;
  dailyLogDateOffset: number;
}



// WEBPACK FOOTER //
// ./src/models/cycles/cycle.models.ts